(() => {
    'use strict';

    const sectionLoad = () => {
        const sections = document.querySelectorAll('#MainContent > .shopify-section');

        sections[0]?.classList.add('hero-section');
        sections[1]?.classList.add('presente-den-section');
        sections[2]?.classList.add('usp-section');
        sections[3]?.classList.add('bello-pack-title-section');
        sections[5]?.classList.add('review-title-section');
        sections[6]?.classList.add('review-section');
        sections[7]?.classList.add('how-work-section');
        sections[9]?.classList.add('small-usp-section');
        sections[10]?.classList.add('compare-section');
        sections[11]?.classList.add('collage-section');
        sections[12]?.classList.add('sub-save-section');
        sections[13]?.classList.add('discover-section');
        sections[14]?.classList.add('discover-usp-section');
    };

    const loadTest = () => {
        const heading = document.querySelector('.usp-section h2.medium-hide.image-with-text__heading');

        if (heading) {
            heading.classList.add('usp-sec-heading');

            heading.insertAdjacentHTML('afterend', `
                <div class="usp-sec-description">
                    <p>Les filtres en pichet standards utilisent des granules de carbone libres et fonctionnent par gravité. Bello utilise un bloc de carbone solide et une pompe, ce qui permet d’éliminer une plus grande variété de contaminants, plus rapidement, avec un niveau de certification plus élevé.</p>
                </div>
            `);
        }

        const packageTitle = document.querySelector('#MainContent > .shopify-section:nth-child(5) .product__title');

        if (packageTitle) {
            document.querySelectorAll('#MainContent > .shopify-section')[4]?.classList.add('bello-package-section');

            packageTitle.insertAdjacentHTML('beforebegin', `
                <div class="bello-pack-tag">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <rect width="20" height="20" rx="10" fill="#597012"/>
                        <path d="M9.99969 15.1399C9.02308 15.1399 8.08647 14.7519 7.39591 14.0614C6.70534 13.3708 6.31738 12.4342 6.31738 11.4576C6.31738 9.00271 9.99969 4.86011 9.99969 4.86011C9.99969 4.86011 13.682 9.00271 13.682 11.4576C13.682 12.4342 13.294 13.3708 12.6035 14.0614C11.9129 14.7519 10.9763 15.1399 9.99969 15.1399Z" fill="#F2E9DB"/>
                    </svg>
                    <span>
                        Tout commence par une eau propre. Ensuite, vous choisissez votre boisson.
                    </span>
                </div>
            `);
        }
    };

    const init = () => {
        sectionLoad();
        loadTest(); 
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();